"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
require("./style.scss");
var model_1 = require("../../model");
var PortalPage_1 = require("../_shared/components/PortalPage");
var layout_1 = require("../_shared/components/layout");
var react_router_dom_1 = require("react-router-dom");
var reportLinks = [
    { title: 'Urenrapport', route: '/report-hours', permission: model_1.Permission.PAGE_REPORT_HOURS },
    { title: 'Gebruikerstijdlijn', route: '/report-timelines', permission: model_1.Permission.PAGE_REPORT_TIMELINES },
    { title: 'Overzicht van Sluit de Dag notities', route: '/closing-day-report', permission: model_1.Permission.PAGE_CLOSING_DAY_REPORT },
];
var Page = /** @class */ (function (_super) {
    __extends(Page, _super);
    function Page(props) {
        return _super.call(this, props) || this;
    }
    Page.prototype.render = function () {
        var _this = this;
        return (React.createElement(PortalPage_1.default, { page: model_1.Permission.PAGE_REPORTS, isLoading: this.props.isLoading, id: "report" },
            React.createElement(layout_1.Wrapper, null,
                React.createElement("ul", { className: "bullet-links" }, reportLinks.map(function (_a) {
                    var title = _a.title, route = _a.route, permission = _a.permission;
                    return (0, model_1.userHasPermission)(_this.props.identity, permission) &&
                        React.createElement("li", { className: "bullet-links--list", key: permission },
                            React.createElement(react_router_dom_1.Link, { to: route }, title));
                })))));
    };
    return Page;
}(React.Component));
var mapStateToProps = function (_a) {
    var reducer = _a.reducer;
    return {
        isLoading: reducer.reportReducer.isLoading,
        identity: reducer.authentication.user,
    };
};
var ReportPage = (0, react_redux_1.connect)(mapStateToProps)(Page);
exports.default = ReportPage;
